define.alias("shared/components/shared/ui/social-profile-switcher/list", "preview-grid/components/shared/ui/social-profile-switcher/list");